if (typeof document !== 'undefined' && document?.URL?.includes('utm_source=pwa')) {
    sessionStorage.setItem('isPWA', '1');
}

// Config
export const APP_NAME = 'reborn-front';
export const API_URL = import.meta.env.VITE_API_URL || '';
export const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL || '';
export const REVISION = import.meta.env.VITE_COMMIT_HASH || 'local';
export const AUTHENTIFICATION_MODE = import.meta.env.VITE_AUTHENTIFICATION_MODE || 'COOKIE';
export const GOOGLE_MAP_KEY = import.meta.env.VITE_GOOGLE_MAP_KEY || '';
export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || '/';
export const PUBLIC_ROOT_URL = import.meta.env.VITE_PUBLIC_ROOT_URL || '/';
export const PUBLIC_DOMAINS = (import.meta.env.VITE_PUBLIC_DOMAINS || '').split(',').map(e => e.trim());
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';
export const WEB_PUSH_PUBLIC_KEY = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY || '';
export const DEVICE_TYPE = import.meta.env.VITE_DEVICE_TYPE || '';
export const CAPTCHA_BYPASS_KEY = import.meta.env.VITE_CAPTCHA_BYPASS_KEY || '';

// App device: WINDOWS | ANDROID | IOS | PWA | WEB | SW
export const DEVICE = typeof document !== 'undefined' ? (['WINDOWS', 'IOS', 'ANDROID'].includes(DEVICE_TYPE) ? DEVICE_TYPE : sessionStorage.getItem('isPWA') ? 'PWA' : 'WEB') : 'SW';

// Router mode
export const ROUTER_MODE = ['ANDROID', 'IOS'].includes(DEVICE) ? 'MEMORY' : 'BROWSER';

// Social links
export const AMAZON_PARTNER_TAG = 'briabra-21';
export const LUMIBRICKS_PARTNER_TAG = 'yttxkucw';
export const SOCIAL_INSTAGRAM = "https://www.instagram.com/BrickfilmsCommunity/";
export const SOCIAL_TIKTOK = "https://www.tiktok.com/@brickfilmscommunity";
export const SOCIAL_DISCORD = "https://discord.gg/UT476RzEZp";
export const SOCIAL_YOUTUBE = "https://www.youtube.com/@BrickfilmsCommunity";
export const SOCIAL_FACEBOOK = "https://www.facebook.com/BrickfilmsCommunity";
export const SOCIAL_TWITTER_FR = "https://twitter.com/BrickfilmsFr";
export const SOCIAL_TWITTER_EN = "https://twitter.com/BrickfilmsEn";
export const SOCIAL_LINKEDIN = "https://www.linkedin.com/company/brickfilms-community/";
export const SOCIAL_AMAZON = `https://www.amazon.fr/?tag=${AMAZON_PARTNER_TAG}`;

// Computes build tag
export const BUILD = `${DEVICE.toLowerCase()}-${REVISION.substring(0, 7)}`;

// Manual config values
export const REFRESH_GUEST_DELAY = 60;
export const REFRESH_USER_DELAY = 7;
export const RENEW_TOKEN_DELAY = 30;
export const REFRESH_HOMEPAGE_DELAY = 15;
export const MESSAGES_BY_PAGE = 10;
export const MESSAGES_BY_PAGE_THREADS = 15;
export const ITEMS_BY_PAGE = 24;
export const ITEMS_BY_PAGE_SMALL = 10;

// Fingerprint config values
export const FINGERPRINT_VERSION = 2;
export const FINGERPRINT_CIPHER = '55499cc7-9c6a-4999-a068-38a80e65b5e8';
export const FINGERPRINT_SIGNATURE = 'a9e48908-a3b0-4551-8051-455ffcd030b4';

// Local storage keys
export const LS_PREFIX = 'bfc_';
export const LS_LNG_INTERFACE = `${LS_PREFIX}currentInterfaceLanguage`;
export const LS_LNG_CONTENT = `${LS_PREFIX}currentContentLanguages`;
export const LS_USER_CACHE = `${LS_PREFIX}userCache`;
export const LS_BADGE_CACHE = `${LS_PREFIX}badgeCache`;
export const LS_APRIL_FOOL = `${LS_PREFIX}imnotfun`;
export const LS_DARK_MODE = `${LS_PREFIX}darkmode`;
export const LS_SURVEY_2024 = `${LS_PREFIX}survey2024`;
export const LS_AUTH = `${LS_PREFIX}auth`;

// Public email
export const PUBLIC_EMAIL = 'brickabrackv3@gmail.com';

// Languages
export const LANGUAGES = [{
    value: 'en',
    label: 'English',
    tLabel: t => t('English'),
}, {
    value: 'fr',
    label: 'Français',
    tLabel: t => t('Français'),
}, {
    value: 'de',
    label: 'Deutsch',
    tLabel: t => t('Deutsch'),
}, {
    value: 'es',
    label: 'Español',
    tLabel: t => t('Español'),
}, {
    value: 'it',
    label: 'Italiano',
    tLabel: t => t('Italiano'),
}, {
    value: 'pt',
    label: 'Português',
    tLabel: t => t('Português'),
}, {
    value: 'pl',
    label: 'Polski',
    tLabel: t => t('Polski'),
    //isExperimental: true,
}];

// Allowed languages
export const ALLOWED_CONTENT_LANGUAGES = ['en', 'fr']; // API should also handle it or it will cause issues
export const ALLOWED_INTERFACE_LANGUAGES = ['en', 'fr', 'de', 'es', 'it', 'pt', 'pl']; // API should also handle it or it will cause issues
export const DEFAULT_LANGUAGE = 'en';

